export default "__VITE_ASSET__54856f2d__"